<template>
    <div class="inline-flex items-center flex-shrink-0 p-4 space-x-2" :class="[alignmentClass, className]">
        <template v-if="sortable">
            <button class="inline-flex items-center font-medium space-x-2" @click="emitSortEvent">
                <slot />
                <template v-if="sort[0] === '-' && isActive">
                    <nio-icon class="mt-0.5 text-xs" name="regular/arrow-down-1" />
                </template>
                <template v-else>
                    <nio-icon class="mt-0.5 text-xs" name="regular/arrow-up-1" />
                </template>
            </button>
        </template>
        <template v-else>
            <slot />
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            align: {
                type: String,
                default: 'left',
            },
            sortable: {
                type: Boolean,
                default: false,
            },
            name: {
                type: String,
                required: true,
            },
            sort: {
                type: String,
                default: '',
            },
            className: {
                type: String,
                default: '',
            },
        },

        computed: {
            alignmentClass() {
                if (this.align === 'center') {
                    return 'justify-center';
                }

                if (this.align === 'right') {
                    return 'justify-end';
                }

                return 'justify-start';
            },

            sortColumnName() {
                return this.sort.replace(/^-/, '');
            },

            isActive() {
                return this.sortColumnName === this.name;
            },
        },

        methods: {
            emitSortEvent() {
                this.$emit('sort', (this.isActive && this.sort[0] !== '-' ? '-' : '') + this.name);
            },
        },
    };
</script>
